import { Component, OnInit, EventEmitter, Output, TemplateRef } from '@angular/core';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription } from 'rxjs';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DomSanitizer,  } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
const FileSaver = require('file-saver');
import { FormsService } from '../../services/forms.service';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { saveAs } from 'file-saver';
import { filter } from 'jszip';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { AddFormReports3CMapComponent } from 'src/app/middleware/common/FormReports3CMap/FormReports3CMap.component';

@Component({
  selector: 'app-PdfReport-data',
  templateUrl: './PDFFormReport.component.html',
  styleUrls: ['./PDFFormReport.component.scss'],
  providers: [DatePipe]
})

export class PDFFormReportComponent implements OnInit {
  databaseId: string;
  organizationId: string;
  currentUser: any;
  OfficeIDList: any=[];
  myOfficeID: any;
  projects: any=[];
  CloseViewDocument:boolean = false; 
  @Output() getClosePDFReportData = new EventEmitter<boolean>();  
  noRecordFound: boolean;
  noRecordFoundCustomField: boolean;
  formID: any;
  formName:string="";
  clickEventsubscriptionFormPDFReportData: Subscription;
  startDate: string;
  endDate: string;
  dateRange: null;
  ProjectStatus: any;
  preoritytext: string="Status";
  title:string="Document Data";
  searchKeyword: string = "";
  selectedDateRanges:any;
  showCustomField:boolean=false;
  SubmitColumnsButton:boolean=false;
  displayColumn:any=[]=[];
  ResponseHolderDetails:any=[]=[];
  projectDocuments:any=[]=[];
  getTagListResponseHolder:any=[]=[];
  showDisplayColumn:boolean=false;
  datatable:any=[]=[];
  gridSettingData:any=[]=[];
  rowDataList:any=[]=[];

  constructor(private formsService:FormsService, private dialog: MatDialog, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    private statusConst: StatusConstant, public sanitizer: DomSanitizer,
    private toastr: ToastrService, 
    private loaderService: LoaderService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.clickEventsubscriptionFormPDFReportData = this._dataSharingService.getselectedPdfFormDataForForm().subscribe((result) => {
      if (result) {     
         this.formID = Object.values(result)[0];  
         this.formName = Object.values(result)[1];  
         this.GetProjectsByFormID();     
      }      
    });  
  }

  ngOnDestroy() {
    this.clickEventsubscriptionFormPDFReportData.unsubscribe()
   } 

   searchFormData(){
    if(this.showDisplayColumn==false){
      this.GetProjectsByFormID();
    } 
    if(this.showDisplayColumn==true){
      this.GetProjectDocument();
    }    
   }

   clearSearchData(){
    this.searchKeyword = "";
    if(this.showDisplayColumn==false){
      this.GetProjectsByFormID();
    }
    if(this.showDisplayColumn==true){
      this.GetProjectDocument();
    } 
   }
   

   clearDateRange(){
    this.dateRange = null;
    this.selectedDateRanges = null
    this.GetProjectsByFormID();
   }

   selectedDateRange(event){
    this.startDate = (moment(event.startDate).format("MM/DD/YYYY"));
    this.endDate = (moment(event.endDate).format("MM/DD/YYYY"));

    this.selectedDateRanges = {
      from: this.startDate,
      to: this.endDate
    }
   }

  downloadAsZip(project:any) {
    this.loaderService.show();
    var ReqModel = {
      projectID: project.projectID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID, 
      databaseID: Number(this.databaseId),
      Urls:project.linksToCompletedDocuent            
    };
    this.formsService.DownloadMultipleAsZipAsync(ReqModel)
      .then(blob => this.triggerDownload(blob,project.projectName))
      .catch(error => {
        this.loaderService.hide();
        console.error('Error fetching the zip file:', error);
      });
  }

  downloadAsZipProject(project:any) {
    this.loaderService.show();
    var ReqModel = {
      projectID: project.projectID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID, 
      databaseID: Number(this.databaseId),
      Urls:project.finalDocuments            
    };
    this.formsService.DownloadMultipleAsZipAsync(ReqModel)
      .then(blob => this.triggerDownload(blob,project.projectName))
      .catch(error => {
        this.loaderService.hide();
        console.error('Error fetching the zip file:', error);
      });
  }

  triggerDownload(blob: Blob,docName:any='Project') {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = docName+' Completed Doc'+'.zip';
    a.click();
    URL.revokeObjectURL(objectUrl);
    this.loaderService.hide();
  }

  clearPreoority() {
    this.preoritytext = "Status";
    this.ProjectStatus = 0;
    this.GetProjectsByFormID();
  }

  onFilterByPreority(type: any, txt: any) {
    this.preoritytext = txt;
    this.ProjectStatus = type;
    this.GetProjectsByFormID();
  }

  GetProjectsByFormID(){
    var ReqModel = {
      formID: Number(this.formID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,     
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),    
      searchKeyword: this.searchKeyword,
      searchDateRange: this.selectedDateRanges,
      ProjectStatus:this.ProjectStatus        
    };
    this.loaderService.show();
    this.formsService.GetProjectsByFormID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.projects = response.data;
          this.projects.forEach(element => {
            element.createdOn=this.datePipe.transform(element.createdOn, "MM/dd/yyyy hh:mm:ss a");
          }); 
        } else {
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }

   SendRemainder(project:any) {
    this.loaderService.show();
    let reqModel = {
      GroupRelationParticipantMappingID: 0,
      ProjectID: project.projectID,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      officeID: this.myOfficeID, 
      databaseID: this.databaseId,
      contactId: 0,
    }
    this.formsService.ResendRemainderProjectReport(reqModel).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        this.toastr.success('The reminder has been sent.');
      } else {
        this.toastr.warning('The project group is not active yet.');
      }
    });
   }

   
   ClosePDFReportData(message:boolean){ 
    this.showCustomField=false;
    this.showDisplayColumn=false;
    this.noRecordFound=false;
    this.noRecordFoundCustomField=false;
    this.projects=[];
    this.projectDocuments=[];
    this.datatable=[];
    this.showCustomColumninList=[];
    this.rowDataList=[];
    this.getClosePDFReportData.emit(message);
   }

   close(){
    this.dialog.closeAll();
   }
  

   applyFilter(templateRef: TemplateRef<any>) {
    this.SubmitColumnsButton = false;   
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  documentSelected:number=0;

   GetProjectDocument() {
    var ReqModel = {
      projectID: Number(this.formID),
      type: 2,// 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
      isSent: (sessionStorage.getItem("isSent") == null || sessionStorage.getItem("isSent") == undefined) ? false : (sessionStorage.getItem("isSent") == 'true' ? true : false)
    };
    this.loaderService.show();
    this.formsService.GetProjectDocuments(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          let data = response.data;      
          this.projectDocuments = data.documents;
          if(this.projectDocuments.length>0){
            let getData:any;
            if (this.projectDocuments && this.projectDocuments.length > 0) {
                getData = this.projectDocuments[0]; // Ensure projectDocuments[0] exists
               if (getData!=null) {
                 this.documentSelected = getData.projectDocumentID;
                 this.showDisplayColumn=true;
                 this.getFormJsonFields(this.documentSelected);
               }
            }
          }     
          this.loaderService.hide();
        } else {     
          this.projectDocuments=[];     
          this.loaderService.hide();
        }
      } else {
        this.projectDocuments=[];
        this.loaderService.hide();
      }
    });
   }

 
  GetDocumentJson(value){
    this.documentSelected=Number(value);
    this.getFormJsonFields(value);
    this.showDisplayColumn=true;
  }

  showCustomColumninList:any=[]=[];

  getFormJsonFields(documentId) {
    var ReqModel = {
      formID: Number(this.formID),
      documentID:Number(documentId),    
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
      searchKey: this.searchKeyword,
    };
    this.loaderService.show();
    this.formsService.getPDFFormReport(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.ResponseHolderDetails = response;
        this.displayColumn=[]; 
        this.datatable=[];
        this.showCustomColumninList=[];
        this.rowDataList=[];
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.getTagListResponseHolder = response.data.reportColumns;
          if(this.getTagListResponseHolder!=null){
            this.getTagListResponseHolder.map((res) => {
              if (res.fieldName=="") {
                res.fieldName = res.fieldTypeName;
              } 
              return res;
            });
            this.displayColumn = this.getTagListResponseHolder;
          }         

          if(response.data.reportDocs!=null){
            this.rowDataList= response.data.reportDocs;
          }
          if(response.data.reportDocs==null){
            this.rowDataList=[];
            this.noRecordFoundCustomField=true;
          }
                          
          this.showCustomColumninList= this.displayColumn.filter(x=>x.isDisplay==true);
                          
          var obj4={
            fieldName: "Status",
            fieldTypeName: "Project Status",
            id: "Project Status",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.unshift(obj4);

          var obj3={
            fieldName: "Participant Emails",
            fieldTypeName: "Participant Emails",
            id: "Participant Emails",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.unshift(obj3);

          var obj2={
            fieldName: "Name",
            fieldTypeName: "Participant Name",
            id: "Participant Name",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.unshift(obj2);

          var obj1={
            fieldName: "Date",
            fieldTypeName: "Created On",
            id: "Created On",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.unshift(obj1);

          var obj5={
            fieldName: "Project Name",
            fieldTypeName: "Project Name",
            id: "Project Name",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.unshift(obj5);
         
          var obj55={
            fieldName: "From",
            fieldTypeName: "From",
            id: "From",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.unshift(obj55);

          var obj6={
            fieldName: "Docs link",
            fieldTypeName: "Docs link",
            id: "Docs link",
            isDisplay: true,
            viewOrder: 0           
          }

          this.showCustomColumninList.push(obj6);

          var obj7={
            fieldName: "Docs",
            fieldTypeName: "Docs",
            id: "Docs",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.push(obj7);

          var obj88={
            fieldName: "Type",
            fieldTypeName: "Type",
            id: "Type",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.push(obj88);

          var obj8={
            fieldName: "Action",
            fieldTypeName: "Action",
            id: "Action",
            isDisplay: true,
            viewOrder: 0           
          }
          this.showCustomColumninList.push(obj8);
         
          this.loaderService.hide();
        } else {   
          this.displayColumn=[]; 
          this.showCustomColumninList=[];
          this.rowDataList=[];
          this.datatable=[];        
          this.loaderService.hide();
        }
      } else { 
        this.displayColumn=[];  
        this.showCustomColumninList=[];
        this.rowDataList=[];
        this.datatable=[];
        this.loaderService.hide();
      }
    });
   }

   getFieldColumnValues(item,FieldColumn) {
    if(FieldColumn.id=="Project Name"){
      return item.projectName;
    }
    if(FieldColumn.id=="Project Name"){
      return item.projectName;
    }
    if(FieldColumn.id=="Created On"){
      return this.datePipe.transform(item.createdOn, "MM/dd/yyyy hh:mm:ss a");;
    }
    if(FieldColumn.id=="Participant Name"){
      return item.name;
    }
    if(FieldColumn.id=="Participant Emails"){
      return item.email;
    }
    if(FieldColumn.id=="Project Status"){
      return item.projectStatus;
    }
    if (item.fields != null) {
      var data = [];
      data = item?.fields.filter(x => x.id == FieldColumn.id);
      if (data != undefined) {
        if (data.length > 0) {
          // if (data[0].fieldName == "Type" && data[0].fieldTypeName == "Dropdown") {
          //   var checkdrp = []
          //   checkdrp = this.AllTypeList.filter(x => x.subFolderID == Number(data[0].value))
          //   if (checkdrp.length > 0) {
          //     return checkdrp[0].folderName;
          //   } else {
          //     return '--';
          //   }
          // }
          // if (data[0].fieldTypeName == "Date") {
          //   if (data[0].value != "") {
          //     return this.datePipe.transform(data[0].value, 'MM-dd-yyyy');;
          //   } else {
          //     return '--';
          //   }
          // }
          if (data[0].val != "") {
            return data[0].val;
          } else {
            return '--';
          }
        } else {
          return '--';
        }
      }

    }
  }


  // getFormJsonFields(documentId) {
  //   var ReqModel = {
  //     formID: Number(this.formID),
  //     documentID:Number(documentId),    
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //     officeIDList: this.OfficeIDList,
  //     officeID: this.myOfficeID,     
  //   };
  //   this.loaderService.show();
  //   this.formsService.getPDFFormReport(ReqModel).subscribe((response) => {
  //     if (response != undefined) {
  //       this.ResponseHolderDetails = response;
  //       this.displayColumn=[]; 
  //       this.datatable=[];
  //       if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
  //         this.getTagListResponseHolder = response.data.reportColumns;
  //         if(this.getTagListResponseHolder.length>0){
  //           this.getTagListResponseHolder.map((res) => {
  //             if (res.fieldName=="") {
  //               res.fieldName = res.fieldTypeName;
  //             } 
  //             return res;
  //           });
  //         }  
  //         this.displayColumn = this.getTagListResponseHolder;  
          
  //         if (this.ResponseHolderDetails.data.reportData != null) {
  //           this.noRecordFoundCustomField = false;
  //           let formData = this.ResponseHolderDetails.data.reportData;
        
  //           if (formData.length > 0) {
  //               for (let i = 0; i < formData.length; i++) {
  //                   let jsonData = [];
  //                   let userData = {
  //                       ctrlType: "text",
  //                       id: "UserName",
  //                       fieldName: "Project Name",
  //                       selectedValue: formData[i].projectName
  //                   };
        
  //                   jsonData = JSON.parse(formData[i].filledParticipantJson);
  //                   if (jsonData.length > 0) {
  //                       jsonData = jsonData[0].fields;
  //                   }
        
  //                   // Add user data to the beginning of jsonData array
  //                   jsonData.splice(0, 0, userData);
        
  //                   // Iterate over jsonData fields
  //                   for (let j = 0; j < jsonData.length; j++) {
  //                       let value = "";
  //                       let existingRecord = this.datatable.find(x => x.id === jsonData[j].id);
        
  //                       if (existingRecord) {
  //                           // If selectedValue is available, use it; otherwise, default to "-"
  //                           value = jsonData[j].selectedValue; //? jsonData[j].value : "-";
        
  //                           // Check if the field is of type 'File' and 'image'
  //                           let fileName = (jsonData[j].name === "File" && jsonData[j].type === "image") 
  //                               ? jsonData[j].FileName 
  //                               : "";
        
  //                           existingRecord.value.push(value);
  //                       } else {
  //                           value = jsonData[j].selectedValue;//jsonData[j].value ? jsonData[j].selectedValue : "-";
        
  //                           let fileName = (jsonData[j].fieldTypeName === "File" && jsonData[j].type === "image") 
  //                               ? jsonData[j].FileName 
  //                               : "";
        
  //                           // Determine the type
  //                           let type = jsonData[j].id.split('-')[0] || "";
        
  //                           // Adjust type for embedded images
  //                           if (type === "embedImage") {
  //                               type = "Image";
  //                           }
        
  //                           // Add the new record to datatable
  //                           let newRecord = {
  //                               columnName: jsonData[j].fieldName,
  //                               type: type,
  //                               id: jsonData[j].id,
  //                               value: [value],
  //                               FileName: fileName
  //                           };
        
  //                           this.datatable.push(newRecord);
  //                       }
  //                   }
  //               }
        
  //               // Normalize the length of 'value' arrays in datatable
  //               if (this.datatable.length > 0) {
  //                   let total = this.datatable[0].value.length;
        
  //                   this.datatable.forEach(record => {
  //                       let currentRecordValue = record.value;
        
  //                       // Adjust the value array length
  //                       if (currentRecordValue.length < total) {
  //                           while (currentRecordValue.length < total) {
  //                               currentRecordValue.push("-");
  //                           }
  //                       } else if (currentRecordValue.length > total) {
  //                           currentRecordValue.length = total;
  //                       }
  //                   });
  //               }
        
  //           this.datatable;
  //           this.gridSettingData=[];
  //           this.gridSettingData = this.ResponseHolderDetails.data.reportColumns;         
  //           if (this.gridSettingData != null) {
  //             if (this.datatable.length > 0) {
  //               for (let i1 = 0; i1 < this.datatable.length; i1++) {
  //                  var checkData=[];
  //                  checkData = this.gridSettingData.filter(x=>x.id==this.datatable[i1].id);
  //                  if(checkData.length>0){
  //                   this.datatable[i1].isDisplay=checkData[0].isDisplay;
  //                  }else{
  //                   this.datatable[i1].isDisplay=true;
  //                  }
  //               }
  //             }
  //           }else{
  //             if(this.datatable.length>0){
  //              this.datatable.forEach(e => {
  //               e.isDisplay = true
  //             });
  //            } 
  //           }
  //          // this.displayColumn = this.datatable;
  //          if(this.datatable.length>0){
  //           this.datatable=this.datatable.filter(x=>x.isDisplay==true);
  //           }
  //           }
  //         }
          
        
  //         if(this.ResponseHolderDetails.data.reportData==null){
  //           this.noRecordFoundCustomField=true;
  //         }

  //         this.loaderService.hide();
  //       } else {   
  //         this.displayColumn=[];         
  //         this.loaderService.hide();
  //       }
  //     } else { 
  //       this.displayColumn=[];  
  //       this.loaderService.hide();
  //     }
  //   });
  //  }

   changeToggleCustom(event: any) {
    if(event.checked==true){  
      this.title= "Document Data";  
      this.showCustomField=true;
      this.showDisplayColumn=false;
      this.displayColumn=[];
      this.datatable=[];
      this.GetProjectDocument();
    }
    if(event.checked==false){
      this.title= "Document Data";
      this.showCustomField=false;
      this.showDisplayColumn=false;  
      this.displayColumn=[];
      this.datatable=[];
      this.GetProjectsByFormID();   
    }
  }

  
   changedToggle(items, event) {
    this.SubmitColumnsButton = true;      
    if(this.displayColumn.length>0){
      this.displayColumn.find((item) => item.id == items.id).isDisplay = event.checked;
    }       
   }

   onSubmitColumns(){
    if(this.displayColumn.length>0){
      var newTable=[];
      var fields=[];
      newTable=this.displayColumn;
      if(newTable.length>0){
        for (let i = 0; i < newTable.length; i++){
          var obj={
           "id": newTable[i].id,
           "fieldName": newTable[i].fieldName,
           "fieldTypeName": newTable[i].fieldTypeName,
           "viewOrder": 0,
           "isDisplay": newTable[i].isDisplay,
           }
           fields.push(obj);
         }
      }      
    }
   var ReqModel={
     fields:fields,
     formID: Number(this.formID), 
     documentID:this.documentSelected,     
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),
     officeID: this.myOfficeID,     
     officeIDList: this.OfficeIDList,
     databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.formsService.addPDFFormUserSetting(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        this.loaderService.hide();
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
           this.toastr.success('Record save successfully', '', {
                timeOut: 3000,
           });
           this.close();  
          this.getFormJsonFields(this.documentSelected);
         } else {
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }

  DownloadFile(record:any,row:any) {
    if (record !== undefined && record !== null) {
      const data = record;//'data:' + record.FileExtention + ';base64,' + record.base64URL;
      FileSaver.saveAs(data, row.FileName);
    }else{
      this.toastr.error('File download failed.', '', {
        timeOut: 3000,
      });
    }
  }


  ExcelData:any=[]=[];
    
  downloadData() {
    // Prepare data for the sheet
    let sheetData: any[] = [];
  
    // Filter out the columns you don't want in the export
    const excludedColumns = ['Docs link', 'Docs', 'Action', 'From', 'Type'];
    const filteredColumns = this.showCustomColumninList.filter(col => !excludedColumns.includes(col.fieldName));
  
    // Add headers from filtered columns
    const headers = filteredColumns.map(col => col.fieldName);
    sheetData.push(headers);
  
    // Add row data
    this.rowDataList.forEach(row => {
      let rowData: any[] = [];
  
      filteredColumns.forEach(col => {
        switch (col.id) {
          case 'Project Name':
            rowData.push(row.projectName);
            break;
          case 'Created On':
            rowData.push(this.datePipe.transform(row.createdOn, 'MM/dd/yyyy'));
            break;
          case 'Participant Name':
            rowData.push(row.name);
            break;
          case 'Participant Emails':
            rowData.push(row.email);
            break;
          case 'Project Status':
            rowData.push(row.projectStatus);
            break;
          default:
            // For other fields, filter based on column id
            const data = row.fields.find(field => field.id === col.id);
            rowData.push(data ? data.val : ''); // Add field value or empty string if not found
            break;
        }
      });
  
      sheetData.push(rowData);
    });
  
    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
  
    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, 'Report.xlsx');
  }

  
  // downloadData(){

  //    // Prepare data for the sheet
  //    let sheetData = [];

  //   // var newshowCustomColumninList:any=[]=[];

  //    //newshowCustomColumninList= this.showCustomColumninList.filter(x=>x.fieldName!='Docs link' && x.fieldName!='Docs' &&  x.fieldName!='Action')
  //    // Add headers from showCustomColumninList
  //    let headers = this.showCustomColumninList.map(col => col.fieldName);
  //    sheetData.push(headers);

  //    sheetData =sheetData[0].filter(x=>x!='Docs link' || x!='Docs' || x!='Action' ||
  //       x!='From' || x!='Type');

  //    // Add row data
  //    this.rowDataList.forEach(row => {
  //     let rowData = [];
  //     this.showCustomColumninList.forEach(col => {
  //         // if (col.id === "From") {
  //         //   if(row.pType==0){
  //         //     rowData.push("Sign Now"); // Push projectName into rowData
  //         //   }
  //         //   if(row.pType==1){
  //         //     rowData.push("Fill"); // Push projectName into rowData
  //         //   }
  //         // }
  //         if (col.id === "Project Name") {
  //           rowData.push(row.projectName); // Push projectName into rowData
  //         }
  //         if (col.id === "Date") {
  //           rowData.push(this.datePipe.transform(row.createdOn, "MM/dd/yyyy")); // Push projectName into rowData
  //         }
  //         if (col.id === "Name") {
  //           rowData.push(row.name); // Push projectName into rowData
  //         }
  //         if (col.id === "Participant Emails") {
  //           rowData.push(row.email); // Push projectName into rowData
  //         }
  //         if (col.id === "Status") {
  //           rowData.push(row.projectStatus); // Push projectName into rowData
  //         }
  //          else {
  //           var data=[];
  //           data = row.fields.filter(x => x.id == col.id); // Filter fields by column id
  //            if (data.length > 0) {
  //                 // Assuming 'val' is an object and col.fieldName is a key in that object
  //               rowData.push(data[0].val); // Safely access the field or push an empty string if not found
  //             } else {
  //                rowData.push(""); // If no data is found, push an empty string to maintain the column structure
  //            }
  //        }
  //     });
  //     sheetData.push(rowData); // Push the processed rowData into sheetData
  //  });
  
  //    // Create worksheet and workbook
  //    let worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  //    let workbook = XLSX.utils.book_new();
  //    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  //    // Generate Excel file and trigger download
  //    XLSX.writeFile(workbook, "Report.xlsx");

  //   // this.ExcelData=[];
  
  //   // /* create a new blank" */
  //   // var wb = XLSX.utils.book_new();
  //   // /* create a worksheet */
  //   // var excel = XLSX.utils.json_to_sheet(this.ExcelData);
  //   // XLSX.utils.book_append_sheet(wb, excel, "Data");
 
  //   // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  //   // const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //   // const data1 = new Blob([excelBuffer], { type: fileType });
  //   // FileSaver.saveAs(data1,"Records.xlsx");

  //  }

   mapPlaceHolder(project:any){
    var datasplit=[];
    var email:string="";
    datasplit = project.participants.split(',');
    if(datasplit.length>0){
      email =datasplit[0];
    }
    const dialogRef = this.dialog.open(AddFormReports3CMapComponent, {   
      data: {
        email:email,
        projectID:project.projectID,
        formID: Number(this.formID),
        pType:Number(project.pType),   
      } 
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
      
      }    
    });
   }

   mapPlaceHolderCustom(project:any){
    var datasplit=[];
    var email:string="";
    datasplit = project.email.split(',');
    if(datasplit.length>0){
      email =datasplit[0];
    }
    const dialogRef = this.dialog.open(AddFormReports3CMapComponent, {
      data: {
        email:email,
        projectID:project.projectID,
        formID: Number(this.formID),
        pType:Number(project.pType),
      }      
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.title= "Document Data";  
        this.showCustomField=true;
        this.showDisplayColumn=false;
        this.displayColumn=[];
        this.datatable=[];
        this.GetProjectDocument();
      }    
    });
   }

   resendEmailtoParticipants(project:any) {    
    let reqModel = {     
      projectID: project.projectID,
      pType:project.pType,
      emails:project.participants,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID), 
      databaseID: Number(this.databaseId),      
    }
    this.loaderService.show();
    this.formsService.resendEmailtoParticipants(reqModel).subscribe(response => {
     if (response != undefined) {
        this.ResponseHolderDetails = response;
        this.loaderService.hide();
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.toastr.success('Mail sent successfully', '', {
            timeOut: 3000,
           });                    
         } else {         
          this.loaderService.hide();
        }
       }else{
        this.loaderService.hide();
      }
    });
   }
}

